import React, { useState } from 'react'
import './Banner_Btn_Component.css'

const Banner_Btn_Component = () => {
    return (
        <section className='Banner_Btn_Component'>
            <div className='banner_div'>
                <div className='img_div'>
                    <img src='/assets/images/small_banner/b1.png' className='banner_img' />
                </div>
            </div>
        </section>
    )
}

export default Banner_Btn_Component
